module.exports = __webpack_public_path__ + "static/img/pre-steam.98c1756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pre-steam.png
// module id = dW+5
// module chunks = 0